import { JSConn } from "@/utilities/js-conn";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation";
import { filter as Rfilter, map as Rmap } from "ramda";
import uuidv4 from "uuid/v4";

export default {
  name: "workQueue",
  components: {
    LoadingAnimation,
  },
  data() {
    return {
      dataLoaded: false,
      loadingMessage: "Loading the tasks...",
      localTasksGroupedByClient: [],
      filter: "",
    };
  },
  computed: {
    workOrderTasksGroupedByClient: function() {
      return this.$store.getters.workOrderTasksGroupedByClient;
    },
    localWorkOrderTasks: function() {
      if (this.filter != "") {
        return Rfilter(item => {
          let clientResult = item.client.search(new RegExp(this.filter, "i"));
          return clientResult > -1;
        }, this.localTasksGroupedByClient);
      } else {
        return this.localTasksGroupedByClient;
      }
    },
  },
  created() {
    const jsConn = new JSConn();
    jsConn.formParams = {
      status: "queued",
    };

    this.$store.dispatch("needWorkOrderTasks", jsConn).then(() => {
      this.dataLoaded = true;
      // copy the data into the local tasks
      this.localTasksGroupedByClient = Rmap(item => {
        const count = item.tasks.length;
        return {
          visible: false,
          browserId: `cl-${uuidv4()}`,
          countOfTasks: count,
          ...item,
        };
      }, this.workOrderTasksGroupedByClient);
    });
  },
};
